import { IHttpError, IHttpService } from './http.interface';
import { injectable } from 'inversify';

@injectable()
export class HttpMock implements IHttpService {
    get<T>(): Promise<[T, IHttpError?]> {
        return Promise.resolve([ {} as T ]);
    }

    post<T>(): Promise<[T, IHttpError?]> {
        return Promise.resolve([ {} as T ]);
    }
}
